import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/cpp/cpp/layouts/default.vue").then(m => m.default || m))
}